import React, { Component } from "react"
import PageHeaderWrapper from "../../../components/PageHeaderWrapper"
import { Avatar, Card, notification, Select, Tooltip, Checkbox, Button, Form, Drawer, Row, Col, Tabs } from 'antd/lib/index'
import Request, { API_URL, LAPI_URL } from '../../../request'
import { connect } from 'react-redux'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import _ from 'lodash'
import { RightsWrapper } from "../../../components/_utils/utils"
import IncentiveInvoicePDF from "../../../components/pdf/incentiveInvoicePDF"
import moment from "moment"
let accountPaymentCompanies = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).accountPaymentCompanies : '';


const TabPane = Tabs.TabPane
const Option = Select.Option
class ShowIncentiveInvoice extends Component {
    state = {
        visible: true,
        incentiveData: {}
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    async componentDidMount() {
        let { invoiceId } = this.props
        let response = await Request.getIncentiveInvoiceById({ id: invoiceId })
        let invoiceSettingResponse = await Request.getCommunicationSettings();
        response.headerLogo = invoiceSettingResponse.doc.headerLogo;
        response.financeEmail = invoiceSettingResponse.doc.financeEmail;
        this.setState({ incentiveData: response })
    }

    downloadInvoice = () => {
        var printContents = document.getElementById('table_with_data').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        setTimeout(() => {
            this.onClose()
        }, 500)
    }

    render() {
        const { visible } = this.state
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Incentive Invoice
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={900}
                visible={visible}>
                <Card>
                    <Tooltip title="Download Invoice">
                        <Button
                            loading={false}
                            shape="circle"
                            icon="download"
                            onClick={() => { this.downloadInvoice() }}
                        />
                    </Tooltip>
                    <Card id="table_with_data">
                        <table style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td>
                                        <IncentiveInvoicePDF generatedInvoice={this.state.incentiveData} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Card>
                </Card>
            </Drawer>
        )
    }
}


@Form.create()
class AddPreviousPayment extends Component {
    state = {
        visible: true
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        },)
    }

    componentDidMount = () => {
    }

    handlePreviousPayment = (e) => {
        let { recordId, form } = this.props;
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData)
            values._id = recordId
            let response = await Request.updateIncentivePreviousPayment(values)
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose()
        })
    }

    render() {
        let { visible } = this.state
        let { form: { getFieldDecorator, setFieldsValue } } = this.props
        let accountPaymentCompaniesArray = [];
        if (accountPaymentCompanies.indexOf(',')) {
            accountPaymentCompaniesArray = accountPaymentCompanies.split(',');
        }

        const inputTypes = {
            fields: [
                {
                    label: 'Previous Paid Amount',
                    key: 'previousAmount'
                },
                {
                    label: 'Payment Method',
                    type: 'select',
                    options: ["CASH", "NEFT", "CHEQUE", "ONLINE"],
                    key: 'paymentMethod',

                    onChange: v => {
                        this.props.form.setFieldsValue({ paymentMethod: v })
                    }
                },
                {
                    label: 'Payment Date',
                    type: 'date',
                    key: 'paymentDate'
                },
                {
                    label: 'Company Paid By',
                    type: 'select',
                    key: 'paidBy',
                    options: accountPaymentCompaniesArray,
                    onChange: v => {
                        setFieldsValue({ paidBy: v })
                    }
                }
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Add Previously Paid Payment
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={600}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handlePreviousPayment} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}

@Form.create()
class ActionIncentiveInvoice extends Component {
    state = {
        visible: true,
        invoiceApprove: false,
        statusPaid: false
    }


    handleSubmit = (e) => {
        let { form, record } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            values.id = record._id;
            let response = await Request.updateIncentiveInvoice(values);
            if (response.success && values.status === "Approve") {
                await Request.sendIncentiveInvoiceOnMail(values)
            }
            if (response.success) {
                notification.success({
                    message: response.msg
                })
            } else {
                notification.error({
                    message: 'Try Again'
                })
            }
            this.onClose()
        })
    }

    sendInvoiceToFinance = (record) => {
        console.log(record)
    }


    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    render() {
        let { record } = this.props
        let accountPaymentCompaniesArray = [];
        if (accountPaymentCompanies.indexOf(',')) {
            accountPaymentCompaniesArray = accountPaymentCompanies.split(',');
        }
        let inputTypes = {
            fields: [
                {
                    label: 'Action',
                    type: 'select',
                    options: ['Approve', 'Disapprove', 'Paid'],
                    key: 'status',
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({ status: v })
                        if (v === "Paid") {
                            this.setState({ statusPaid: true })
                        } else {
                            this.setState({ statusPaid: false })
                        }
                    }
                },
                {
                    label: 'Amount',
                    type: 'text',
                    key: 'payment',
                    required: this.state.statusPaid,
                    hidden: !this.state.statusPaid,
                },
                {
                    label: 'Payment Method',
                    type: 'select',
                    options: ["CASH", "NEFT", "CHEQUE", "ONLINE"],
                    key: 'paymentMethod',
                    required: this.state.statusPaid,
                    hidden: !this.state.statusPaid,
                    onChange: v => {
                        this.props.form.setFieldsValue({ paymentMethod: v })
                    }
                },
                {
                    label: 'Company Paid By',
                    type: 'select',
                    key: 'paidBy',
                    options: accountPaymentCompaniesArray,
                    required: this.state.statusPaid,
                    hidden: !this.state.statusPaid,
                    onChange: v => {
                        this.props.form.setFieldsValue({ paidBy: v })
                    }
                }
            ]
        }
        let { visible } = this.state
        let { form: { getFieldDecorator } } = this.props
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Approve/Disapprove
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={600}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}


class IncentiveInvoice extends Component {
    state = {
        count: 0,
        record: {},
        showApproveForm: false,
        showInvoiceDrawer: false,
        showPreviousPaymentDrawer: false,
        invoiceId: null,
        activeTab: "0",
        status: "Under Review",
        allStatus: ["Under Review", "Approved", "Disapproved", "Paid"]
    }

    callback = (value) => {
        if (value) {
            this.chooseTab(value)
        }
    }

    reload = () => {
        this.table.current.reload();
    };

    chooseTab(activeTab) {
        let status = "Under Review";
        if (activeTab == 1) {
            status = "Approved"
        } else if (activeTab == 2) {
            status = "Paid"
        }
        this.setState({
            activeTab,
            status
        })
    }

    apiRequest = async (params) => {
        return new Promise(async (resolve) => {
            if (!params.sortField) {
                params.sortField = 'createdDate'
                params.sortOrder = 'descend'
            }
            params.status = this.state.status;
            let response = await Request.getIncentiveInvoices(params)
            this.setState({ count: response.total })
            resolve(response)
        })
    }

    handleEdit = (recordId) => {
        this.setState({ record: recordId, showApproveForm: true })
    }

    showInvoice = (recordId) => {
        this.setState({ invoiceId: recordId, showInvoiceDrawer: true })
    }

    addPreviousPayment = (recordId) => {
        this.setState({ invoiceId: recordId, showPreviousPaymentDrawer: true })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    onClose = () => {
        this.setState({ showApproveForm: false, record: {}, showInvoiceDrawer: false, invoiceId: null }, () => {
            this.table.current.reload()
        })
    }

    closePreviousDrawer = () => {
        this.setState({ showPreviousPaymentDrawer: false, invoiceId: null }, () => {
            this.table.current.reload()
        })
    }


    render() {
        const columns = [
            {
                title: 'Name',
                key: 'name',
                dataIndex: 'userId.name',
                render: (text, record) => (

                    <Tooltip>
                        <a
                            target={"_blank"}
                            href={`/desk/incentive?userId=${record.userId._id}&status=${record.status}`}
                        >
                            {text}
                        </a>
                    </Tooltip>
                )
            },
            {
                title: 'Status',
                key: 'status',
                dataIndex: 'status',
                render: (text, record) => (
                    <div>{record && record.status === 'Paid' ? `${record.status} - (${record.paymentMethod}-${record.paidBy ? record.paidBy : ""})` : record.status}</div>
                )
            },
            {
                title: 'Type',
                key: 'type',
                dataIndex: 'type',
                render: (text, record) => (
                    record.type ? record.type : 'Regular'
                )
            },
            {
                title: 'Amount',
                key: 'totalAmount',
                dataIndex: 'totalAmount',
                render: (text, record) => {
                    let alreadyPaid = 0
                    if (record.payments) {
                        _.each(record.payments, (payment) => {
                            alreadyPaid += payment.amount
                        })
                    }
                    return (
                        <div>{record.totalAmount - alreadyPaid}</div>
                    )
                }
            },
            {
                title: 'Already Paid',
                key: 'payments',
                render: (text, record) => {
                    let totalPaid = 0;
                    if (record.payments && record.payments.length > 0) {
                        _.each(record.payments, (payment) => {
                            totalPaid += payment.amount
                        })
                    }
                    return (
                        <div>{totalPaid}</div>
                    )
                }
            },
            {
                title: 'Incentive Term',
                key: 'incentiveTerm',
                render: (text, record) => {
                    if (!record.type) {
                        let { userId } = record
                        let startMonth = null
                        let endMonth = null
                        if (userId && !userId.incentiveTerm || userId && userId.incentiveTerm === "Quaterly") {
                            startMonth = moment(record.createdByUser.time).subtract(3, 'months').startOf('month').format('MMM-YYYY')
                            endMonth = moment(record.createdByUser.time).subtract(1, 'month').startOf('month').format('MMM-YYYY')
                        } else if (userId && userId.incentiveTerm === "Monthly") {
                            startMonth = moment(record.createdByUser.time).subtract(1, 'month').startOf('month').format('MMM-YYYY')
                        } else if (userId && userId.incentiveTerm === "Half-Yearly") {
                            startMonth = moment(record.createdByUser.time).subtract(6, 'months').startOf('month').format('MMM-YYYY')
                            endMonth = moment(record.createdByUser.time).subtract(1, 'month').startOf('month').format('MMM-YYYY')
                        } else if (userId && userId.incentiveTerm === "Yearly") {
                            startMonth = moment(record.createdByUser.time).subtract(1, 'year').startOf('month').format('MMM-YYYY')
                            endMonth = moment(record.createdByUser.time).subtract(1, 'month').startOf('month').format('MMM-YYYY')
                        }
                        return (
                            <div>{startMonth}{endMonth ? ` - ${endMonth}` : null}</div>
                        )
                    } else {
                        return (
                            <div>N/A</div>
                        )
                    }
                }
            },
            {
                title: 'Last Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                searchTextName: 'updatedByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                dataindex: 'operation',
                render: (text, record) => (
                    <React.Fragment>
                        <RightsWrapper myRight="EditIncentiveInvoice.view">
                            <Tooltip title="Click To Edit Invoice">
                                <Button
                                    shape="circle"
                                    size={"small"}
                                    icon="edit"
                                    onClick={() => this.handleEdit(record)}
                                />
                            </Tooltip>
                        </RightsWrapper>
                        <Tooltip title="Click To Show Invoice">
                            <Button
                                shape="circle"
                                size={"small"}
                                icon="eye"
                                onClick={() => this.showInvoice(record._id)}
                            />
                        </Tooltip>
                        {
                            record.type && record.status != "Paid" && record.type === "Previous" ?
                                <Tooltip title="Previous Payments">
                                    <Button
                                        shape="circle"
                                        size={"small"}
                                        icon="forward"
                                        onClick={() => this.addPreviousPayment(record._id)}
                                    />
                                </Tooltip>

                                : null
                        }
                    </React.Fragment>
                )
            }
        ]
        let { showApproveForm, record, showInvoiceDrawer, invoiceId, allStatus, showPreviousPaymentDrawer } = this.state
        return (
            <PageHeaderWrapper title={` Incentive Invoice : ${this.state.count}`}>
                {
                    showPreviousPaymentDrawer ?
                        <AddPreviousPayment recordId={this.state.invoiceId} onClose={this.closePreviousDrawer} />
                        : null
                }
                {
                    showApproveForm ?
                        <ActionIncentiveInvoice record={record} onClose={this.onClose} />
                        : null
                }
                {
                    showInvoiceDrawer ?
                        <ShowIncentiveInvoice invoiceId={invoiceId} onClose={this.onClose} />
                        : null
                }
                <Card bordered={true}>
                    <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
                        <TabPane tab={'All'} key={0}>
                            <Row>
                                <Col span={4}>
                                    <label>Search By Status</label>
                                    <Select
                                        allowClear
                                        showSearch={true}
                                        style={{ width: '90%' }}
                                        defaultValue={this.state.status}
                                        value={this.state.status}
                                        placeholder="Select Status"
                                        optionFilterProp="name"
                                        onChange={status => {
                                            this.setState({
                                                status: status
                                            },
                                                () => {
                                                    setTimeout(() => {
                                                        this.table.current.reload()
                                                    }, 500);
                                                }
                                            )
                                        }}
                                    >
                                        {
                                            allStatus.map((val, idn) => {
                                                return (
                                                    <Option key={idn} value={val}>{val}</Option>
                                                )
                                            })
                                        }

                                    </Select>
                                </Col>
                            </Row>
                            <TableComp
                                columns={columns}
                                ref={this.table}
                                apiRequest={this.apiRequest}
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 20,
                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                }}
                            />
                        </TabPane>
                        <TabPane tab={"Approved"} key={1}>
                            <TableComp
                                columns={columns}
                                ref={this.table}
                                apiRequest={this.apiRequest}
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 20,
                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                }}
                            />
                        </TabPane>
                        <TabPane tab={"Paid"} key={2}>
                            <TableComp
                                columns={columns}
                                ref={this.table}
                                apiRequest={this.apiRequest}
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 20,
                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                }}
                            />
                        </TabPane>
                    </Tabs>
                </Card>
            </PageHeaderWrapper>
        )
    }
}



const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IncentiveInvoice)